var exportModule = angular.module('t2g.export', [
  'ui.router',
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.userSessionService').name,
]);

module.exports = exportModule;

exportModule.config(function($stateProvider) {
  $stateProvider.state('private.main.export', {
    url: '/export',
    title: 'Export',
    templateUrl: '/app/modules/export/ExportView.html?v=4.5.6',
    controller: 'ExportCtrl',
    resolve: {
      objectResolve: function($q, ObjectModel) {
        var deffered = $q.defer();

        ObjectModel.get(function(error, response) {
          if (error) {
            deffered.reject(error);
          } else {
            deffered.resolve(response);
          }
        });

        return deffered.promise;
      },
    },
  });
});

exportModule.controller('ExportCtrl', function($scope, objectResolve, UserSession, settings, gettextCatalog) {
  $scope.objects = objectResolve;
  $scope.settings = settings;
  var userSession = UserSession.get();
  var now = new Date();
  var invoiceExportOptions = require('t2g.common.invoiceExportOptions')(gettextCatalog);

  $scope.invoiceExport = {
    month: null,
    year: now.getFullYear(),
    billingType: invoiceExportOptions.defaultBillingType,
  };
  $scope.invoiceExportBillingTypes = invoiceExportOptions.billingTypes;
  $scope.invoiceExportMonths = [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  $scope.invoiceExportYears = [];

  for (var year = now.getFullYear(); year >= now.getFullYear() - 10; year -= 1) {
    $scope.invoiceExportYears.push(year);
  }

  $scope.getCustomerDownloadLink = function() {
    return '/api/office/' + userSession.office + '/export/kundenliste.csv';
  };

  $scope.getInvoiceDownloadLink = function() {
    var link =
      '/api/office/' +
      userSession.office +
      '/export/rechnungen.csv?year=' +
      $scope.invoiceExport.year;

    if ($scope.invoiceExport.month) {
      link += '&month=' + $scope.invoiceExport.month;
    }

    link += '&billingType=' + $scope.invoiceExport.billingType;

    return link;
  };

  $scope.getInvoicePdfDownloadLink = function() {
    var link =
      '/api/office/' +
      userSession.office +
      '/export/rechnungen.zip?year=' +
      $scope.invoiceExport.year;

    if ($scope.invoiceExport.month) {
      link += '&month=' + $scope.invoiceExport.month;
    }

    link += '&billingType=' + $scope.invoiceExport.billingType;

    return link;
  };

  $scope.getAppointmentDownloadLink = function(object) {
    return (
      '/api/office/' + userSession.office + '/export/appointments/' + object._id + '/termine.ics'
    );
  };
});



// WEBPACK FOOTER //
// ./src/app/modules/export/exportModule.js